// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"98d31f58","264":"70efd6fd","386":"dbdb72b9","453":"f5be1575","603":"83ce716a","821":"012e1d94","835":"fffb57cb","879":"e4074ea9"}[chunkId] + ".chunk.js";
};